import { z } from 'zod'

/**
 * Provider connection states, each meaning something different to the user.
 *
 * `.catch` keeps an unrecognised provider status from throwing — a new state
 * upstream should degrade to "unknown", not blank the connections page.
 */
export const connectionStatusSchema = z
  .enum(['INITIATED', 'INITIALIZING', 'ACTIVE', 'FAILED', 'EXPIRED', 'INACTIVE'])
  .catch('INACTIVE')

export const connectionSchema = z
  .object({
    id: z.string(),
    toolkit_slug: z.string().nullish(),
    status: connectionStatusSchema,
    status_reason: z.string().nullish(),
    is_disabled: z.boolean().optional().default(false),
    created_at: z.string().nullish(),
    updated_at: z.string().nullish(),
    toolkit_name: z.string().nullish(),
    toolkit_logo: z.string().nullish(),
    display_label: z.string().nullish(),
    approved_count: z.number().nullable().optional(),
    requires_approval: z.boolean().nullable().optional(),
    permissions_status: z.enum(['ready', 'unavailable']).optional(),
  })

export const connectionListSchema = z.object({
  items: z.array(connectionSchema).default([]),
  total: z.number().optional(),
})

/** `POST /v1/integrations/connections` — what the browser polls next. */
export const connectStartSchema = z.object({
  connection_id: z.string(),
  status: connectionStatusSchema.optional(),
  redirect_url: z.string().nullish(),
  toolkit_slug: z.string().nullish(),
})
